import SFetch from '@app/utils/sfetch'

onDomLoad(($dom) => {
  $dom
    .find("[data-behaviour='fetch-package-confirmation-modal']")
    .each((index, el) => {
      el.addEventListener('click', async () => {
        const packageNames = await SFetch.jsonWithAlert(
          el.dataset.packagesUrl,
          { method: 'GET' }
        )

        if (!packageNames) return

        if (packageNames.length === 0) {
          await SFetch.raw(el.dataset.url, {
            method: el.dataset.submitMethod,
          })
          window.Turbolinks.visit(window.location.toString(), {
            action: 'replace',
          })
        } else {
          window.modalCitizen.openModalPortal(
            'enable-market-package-confirmation-modal',
            {
              entityName: el.dataset.entityName || '',
              marketPackageNames: JSON.stringify(packageNames),
              successUrl: el.dataset.url || '',
              submitMethod: el.dataset.submitMethod || '',
            }
          )
        }
      })
    })
})
